import React from 'react';
import { Check } from 'lucide-react';

const ServiceCard = ({ service, index }) => {
  const Icon = service.icon;
  const isEven = index % 2 === 0;

  return (
    <div className={`grid md:grid-cols-2 gap-12 items-center ${!isEven ? 'md:grid-flow-dense' : ''}`}>
      {/* Image */}
      <div className={`relative ${!isEven ? 'md:col-start-2' : ''}`}>
        <div className="relative z-10 rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300">
          <img
            src={service.image}
            alt={service.title}
            className="w-full h-[400px] object-cover"
          />
        </div>
        <div className="absolute -bottom-4 -right-4 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-2xl opacity-20"></div>
      </div>

      {/* Content */}
      <div className={`space-y-6 ${!isEven ? 'md:col-start-1 md:row-start-1' : ''}`}>
        <div className="inline-block p-3 bg-blue-50 rounded-lg">
          <Icon className="w-10 h-10 text-blue-600" />
        </div>
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
          {service.title}
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed">
          {service.description}
        </p>
        <ul className="space-y-3">
          {service.features.map((feature, idx) => (
            <li key={idx} className="flex items-start space-x-3">
              <Check className="w-5 h-5 text-blue-600 mt-1 flex-shrink-0" />
              <span className="text-gray-700">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ServiceCard;